import { LoyaltyGetRewards } from "components/organisms/LoyaltyGetRewards";
import { useGetExpSettingCurrency } from "../../queries/useGetExpSettingCurrency";

export const LoyaltyGetRewardsContainer = () => {
  const { exp } = useGetExpSettingCurrency();
  return <LoyaltyGetRewards exp={exp} />;
};
